/* eslint-disable camelcase */
import getCart from './getCart';
import updateCartCount from './updateCartCount';


// Accepts an array of items: [{ id, quantity, sellingPlan, properties }]
const addToCart = async (itemsArray) => {
  const items = {
    items: itemsArray.map(item => {
      const payload = {
        id: item.id,
        quantity: item.quantity
      };
      if (item.sellingPlan) {
        payload.selling_plan = item.sellingPlan;
      }
      if (item.properties) {
        payload.properties = item.properties;
      }
      return payload;
    })
  };

  try {
    const atc = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(items)
    });
    const data = await atc.json();
    if (!atc.ok) {
      throw new Error(data.description || data.message || 'Add to cart failed');
    }
    const cart = await getCart();
    updateCartCount(cart.item_count);
    return data;
  } catch (err) {
    console.error('Add to cart error:', err);
    throw err;
  }
};

export default addToCart;
